import ReactDOM from 'react-dom/client';
import App from './Components/App';
import { AppProvider } from './Components/AppContext';
import './index.css';
const root = ReactDOM.createRoot(
  document.getElementById('edullaChatRoot') as HTMLElement
);

root.render(
  <AppProvider>
    <App />
  </AppProvider>
);
